import { COUNTRY } from 'src/app/shared/constants/configObjectProperties';
import { getConfig } from 'src/app/utils/config';

export const getPaymentsWidgetNation = () => getConfig(COUNTRY) ?? 'AU';
